<template>
  <div>
    <ul v-if="values.length" class="product-card-characteristics" :class="{'product-card-characteristics--only-desktop': onlyDesktop}">
      <li v-for="(characteristic, index) in values"
          :key="index"
          class="product-card-characteristics__item characteristic"
          :class="[size ? 'characteristic--' + size : '']">
        <span class="characteristic__name">{{ characteristic['name'] }}:</span>
        <span class="characteristic__value">{{ characteristic['value'] }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ProductCardCharacteristics',
  props: {
    values: Array,
    size: {
      type: String,
      default: ''
    },
    onlyDesktop: {
      type: Boolean,
      default: false
    },
    productPage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      initialOffset: state => state.productTabs.initialOffset
    })
  },
  methods: {
    ...mapActions(['SET_ACTIVE_TAB']),
    setActiveTab () {
      const data = {
        string: 'characteristics',
        top: this.initialOffset - 50
      }
      this.SET_ACTIVE_TAB(data)
    }
  }
}
</script>

<style lang="sass" scoped>

.product-card-characteristics
  +list-unstyled

  &--only-desktop
    display: none
    +mmin(767)
      display: block

.characteristic
  color: $placeholder-color
  font-size: 14px
  line-height: 18px
  font-weight: 400 //Rubik 300

  +mmin($tablet)
    font-weight: 400

  &--medium
    font-size: 14px
    line-height: 17px
    font-weight: 400

.characteristic__name
  margin-right: 5px

.characteristic__value
  color: $text-color

.fake-link
  color: #3e77aa
  font-size: 14px
  border-bottom: 1px dashed #3e77aa
  cursor: pointer
  margin-top: 20px
  display: inline-block

</style>

<style lang="scss" scoped>
.product-card-characteristics {
  &__item {
    border-bottom: 1px solid #E7E7E7;
    padding: 8px 0;
    margin: 0;
  }
}
</style>
